module.exports = __webpack_public_path__ + "static/media/icon1-active.7bd37cd2.svg";